import { useQuery } from '@tanstack/react-query'
import { useSupabaseClient } from 'src/api/supabase'
import { useOrgsApi } from 'src/api/db/apiOrgs'
import { useOrgUsersApi } from 'src/api/db/apiOrgUsers'
import type { User } from './types'

export const useSignupSuccessData = (orgId: string | null) => {
  const supabase = useSupabaseClient()

  const { organizationById, updateOrganization } = useOrgsApi({
    org_id: orgId || undefined,
  })

  const { updateUser } = useOrgUsersApi()

  const { data: orgUserData } = useQuery({
    queryKey: ['orgUserByOrgId', orgId],
    queryFn: async () => {
      if (!orgId) return null
      const { data } = await supabase
        .from('org_user')
        .select('*, user!org_user_user_id_fkey(*)')
        .eq('organization_id', orgId)
        .maybeSingle()
      return data
    },
    enabled: !!orgId,
  })

  const organization = organizationById?.data
  const user = orgUserData?.user as User | undefined

  return {
    organization,
    user,
    updateOrganization,
    updateUser,
  }
}

